export const trimText = (text: string): string => {
  if (!text || typeof text !== 'string') {
    return '';
  }
  return text.trim();
};

export const formatText = (name: string): string => {
  if (!name || typeof name !== 'string') {
    return '';
  }
  return name
    .replace(/[^a-zA-Z0-9\s'()-]/g, '')
    .trim()
    .replace(/(?<=\s|^)[a-zA-Z]/g, (char) => char.toUpperCase());
};

/**
 * SEE-1388: onboarding cities go to Highnote, whose `locality` allows any letter (accents included)
 * plus a few punctuation marks. `formatText` would strip `é` from "Española" without telling anyone.
 */
export const formatCity = (city: string): string => {
  if (!city || typeof city !== 'string') {
    return '';
  }
  return city
    .replace(/[^\p{L}\d\s'(),\-.:/*+]/gu, '')
    .trim()
    .replace(/(?<=\s|^)\p{L}/gu, (char) => char.toUpperCase());
};

export const formatSentenceCase = (name: string): string => {
  // Handle null, undefined, or empty strings
  if (!name || typeof name !== 'string') {
    return '';
  }

  const cleaned = name.replace(/[^a-zA-Z0-9\s'()-]/g, '').trim();

  // Handle empty string after cleaning
  if (cleaned.length === 0) {
    return '';
  }

  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
};

export const formatAddress = (name: string): string => {
  if (!name || typeof name !== 'string') {
    return '';
  }
  return (
    name
      // `/` kept (SEE-1388): Highnote accepts "111 1/2 Center Street", and stripping it made "12".
      .replace(/[^a-zA-Z0-9\s'().,\-/]/g, '')
      .trim()
      .replace(/(?<=\s|^)[a-zA-Z]/g, (char) => char.toUpperCase())
  );
};

export const formatEmail = (email: string): string => {
  if (!email || typeof email !== 'string') {
    return '';
  }
  return email.trim().replace(/\s+/g, '').replace(/\.$/, '').toLowerCase();
};

export const formatName = (name: string): string => {
  if (!name || typeof name !== 'string') {
    return '';
  }
  return name
    .replace(/[^a-zA-ZÀ-ÿ\s'().-]/g, '') // Removed 0-9
    .trim()
    .replace(/(?<=\s|^|-)[a-zA-ZÀ-ÿ]/g, (char) => char.toUpperCase())
    .replace(/(?<=\bSt)\./g, '.');
};

export const sanitizePostalCode = (postalCode: string): string => {
  if (!postalCode || typeof postalCode !== 'string') {
    return '';
  }
  return postalCode.replace(/[^a-zA-Z0-9()]/g, '').trim();
};

export const sanitizeText = (name: string): string => {
  if (!name || typeof name !== 'string') {
    return '';
  }
  return name.replace(/[^a-zA-Z0-9\s'()-]/g, '').trim();
};
